export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const stats = [
    { label: '部漫画资源', value: '10万+' },
    { label: '部作品每日更新', value: '300+' },
    { label: '万漫画爱好者', value: '500+' },
  ];

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20abstract%20background%20with%20soft%20circular%20planet%20shapes%20in%20orange%20and%20amber%20tones%2C%20subtle%20comic%20panel%20textures%20blended%20with%20gradient%20layers%2C%20minimalist%20modern%20design%2C%20clean%20warm%20atmosphere%2C%20Japanese%20manga%20aesthetic%20with%20soft%20lighting%2C%20no%20text%2C%20no%20characters%2C%20abstract%20geometric%20composition&width=1600&height=900&seq=hero-bg-comics-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-24 pb-8 md:pb-0">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium mb-5 tracking-wide">
              免费漫画全集 · 下拉式阅读
            </span>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-4">
              星球漫画
              <br />
              <span className="text-primary-300">
                免费在线看漫画网站大全
              </span>
            </h1>

            <p className="text-background-50/80 text-base md:text-lg lg:text-xl mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed">
              星球漫画汇聚海量免费漫画资源，提供下拉式沉浸阅读体验。涵盖热血冒险、恋爱校园、玄幻修仙、悬疑推理等全品类题材，
              每日更新超过三百部作品，免VIP追更全集。无论你是国漫铁粉还是日漫爱好者，星球漫画都能让你找到心仪的好看漫画，
              随时随地畅享免费在线漫画阅读乐趣。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-300 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-background-50/70 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#index');
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg font-semibold text-base transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line text-lg"></i>
                开始阅读
              </a>
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#carousel');
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 border border-background-50/30 hover:bg-background-50/10 text-background-50 rounded-lg font-semibold text-base transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-star-line text-lg"></i>
                精选推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex items-center justify-center pb-8 md:pb-0">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20a%20digital%20tablet%20displaying%20colorful%20comic%20panels%20with%20Japanese%20manga%20style%20artwork%2C%20surrounded%20by%20floating%20comic%20pages%20and%20speech%20bubbles%20in%20warm%20orange%20and%20amber%20tones%2C%20modern%20digital%20reading%20concept%2C%20clean%20minimal%20background%20with%20subtle%20planet%20silhouette%2C%20no%20text%20visible&width=1200&height=900&seq=hero-visual-comics-02&orientation=landscape"
                alt="星球漫画在线阅读体验"
                title="星球漫画在线免费漫画阅读"
                className="w-full h-full object-cover rounded-xl"
              />
              <div className="absolute inset-0 rounded-xl ring-1 ring-background-50/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}